<!--
    @name: Upload 上传样式重写
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-12-16 16:48:05
-->
<template>
  <div>
    <div v-if="listType=='text'" class="upload-text">
      <el-upload v-bind="$attrs" v-on="$listeners"
                 ref="upload"
                 :before-upload="beforeAvatarUpload">
        <span class="btn">上传附件</span>
        <div slot="tip" class="info">支持格式为.{{format.join('/.')}}的文件，大小不超过{{ size }}MB</div>
        <template slot="file" slot-scope="{file}">
          <div class="fileitem">
            <img :src="toformatconfig(file.name.split('.')[1])" :alt="file.name.split('.')[1]">
            <div style="flex: 1">
              <div style="line-height: 1rem;margin-bottom: 4px">
                <span class="title" :style="{maxWidth: `calc(163px - ${6.65*file.name.split('.')[1].length}px)`}">{{file.name.split('.')[0]}}.</span>
                <span style="position: absolute;display: inline-block;">{{file.name.split('.')[1]}}</span>
              </div>
              <div class="context">
                <span style="width: 70px">{{file.size|tosize}}</span>
                <span style="color: var(--Cfs5);width: 66px">上传完成</span>
                <span style="color: var(--Cfs1)" @click="onRemove?onRemove(file):$refs.upload.handleRemove(file)">删除</span>
              </div>
            </div>
          </div>
        </template>
      </el-upload>
    </div>
    <div v-else>
      <div class="upload-img">
        <el-upload v-bind="$attrs" v-on="$listeners"
                   list-type="picture-card"
                   :before-upload="beforeAvatarUpload"
                   :on-preview="handlePictureCardPreview">
          <span style="line-height: 1em;margin-top: 25px;display: inline-block">
            <i class="el-icon-plus"></i>
            <div class="el-upload__text text">点击上传</div>
          </span>
          <div slot="tip" class="info">请上传{{ size }}MB以内的.{{format.join(' ')}}格式图</div>
        </el-upload>
      </div>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "ui-upload",
  inheritAttrs: false,
  props:{
    listType:{
      type:String,
      default:'picture-card'
    },
    onPreview:{
      type:Function
    },
    beforeUpload:{
      type:Function
    },
    onRemove:{
      type:Function
    },
    format:{
      type:Array,
      default(){
        return 'bmp png jpg gif jpeg'.split(' ')
      }
    },
    fileSize:{
      type:Number,
      default() {
        return 0;
      }
    }
  },
  data(){
    return {
      size:this.fileSize?this.fileSize:this.listType=='text'?50:10,//图片限制10M,文件限制50M
      dialogImageUrl: '',
      dialogVisible: false,
      formatconfig:{
        file:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734192963.png',
        pdf:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734375373.png',
        png:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734192963.png',
        jpg:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734192963.png',
        jpeg:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734192963.png',
        zip:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734428437.png',
        rar:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734428437.png',
        doc:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734403170.png',
        docx:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734403170.png',
        xls:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734388574.png',
        xlsx:'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639734388574.png'
      },
    }
  },
  methods:{
    //预览
    handlePictureCardPreview(file) {
      if(this.onPreview){
        this.onPreview(file)
        return;
      }
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传前
    beforeAvatarUpload(file){
      if(this.beforeUpload){
        return this.beforeUpload(file)
      }

      let isFormat = false;
      let format=file.type.split('/')[1];
      this.format.map(v=>{
        if(format.indexOf(v)>-1){
          isFormat = true;
        }
      })
      if (!isFormat) {
        this.$message.error('不支持的文件格式!');
      }

      const isLtSize = file.size / 1024 / 1024 < this.size;
      if (!isLtSize) {
        this.$message.error(`上传图片大小不能超过${this.size}MB!`);
      }
      return isFormat && isLtSize;
    },
    //格式计算
    toformatconfig(f){
      let url=this.formatconfig[f]
      if(url)return url;
      else return this.formatconfig.file
    }
  },
  filters:{
    tosize(v){
      if(v){
        if(v<1024)return `${v}KB`
        return `${(v/1024/1024).toFixed(2)}MB`
      }
      return ' '
    }
  }
}
</script>

<style scoped lang="scss">
.upload-img{
  border-color: #FFFFFF;
  /deep/.el-upload{
    &:focus{
      border-color: var(--Czsd);
      color: var(--Czsd);
    }
  }
  /deep/.el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 100px;
    .el-icon-plus{
      font-size: 24px;
      color: var(--Czsd);
    }
    .text{
      color:var(--FC9);
      font-size: var(--FS2);
      line-height: var(--FS2);
      margin-top: 6px;
    }
    &:hover{
      border-color: var(--Czsd);
      color: var(--Czsd);
    }
  }
  /deep/.el-upload-list--picture-card{
    display: inline-flex;
    .el-icon-check{
      position: absolute;
      right: 15px;
    }
  }
  /deep/.el-upload-list__item{
    width: 100px;
    height: 100px;
    line-height: 100px;
    margin: 0 10px 10px 0;
  }
}
.upload-text{
  /deep/.el-upload{
    .btn{
      width: 98px;
      height: 34px;
      line-height: 34px;
      display: inline-block;
      margin-bottom: 10px;
      border-radius: 5px;
      text-align: center;
      border: 1px solid var(--Czsd);
      color: var(--Czsd);
      &:hover{
        opacity: 0.9;
      }
    }
  }
  /deep/.el-upload-list{
    .el-upload-list__item{
      display: inline-block;
      width: auto;
      cursor: pointer;
      margin-top: 15px;
      &:hover{
        background: #FFFFFF;
      }
    }
    .fileitem{
      box-sizing: border-box;
      width: 236px;
      height: 60px;
      background: #FAFAFA;
      padding: 10px;
      display: flex;
      margin: 0 10px 10px 0;
      &:hover{
        background: #F5F7FA;
      }
      img{
        width: 32px;
        height: 40px;
        margin-right: 10px;
      }
      .title{
        text-overflow:ellipsis;
        overflow:hidden;
        display: inline-block;
      }
      .context{
        span{
          display: inline-block;
        }
      }
    }
  }

}
.info{
  color:var(--FC9);
  font-size: var(--FS3);
}
</style>
